// extracted by mini-css-extract-plugin
export var audioPlayer = "_qs-0";